import { render, staticRenderFns } from "./Criar.vue?vue&type=template&id=3519afde&scoped=true&"
import script from "./Criar.vue?vue&type=script&lang=js&"
export * from "./Criar.vue?vue&type=script&lang=js&"
import style0 from "./Criar.vue?vue&type=style&index=0&id=3519afde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3519afde",
  null
  
)

export default component.exports